// extracted by css-extract-rspack-plugin
export default {"banners":"Banners-module__banners--t6wl0"};